//import material-UI
import {makeStyles, createStyles, withStyles, Theme} from "@material-ui/core/styles";
import {
  Box,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  Typography,
  IconButton,
} from "@material-ui/core";
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../../features/store";
import {
  checkListCloseAction,
  checkListSwitchAction,
} from "../../features/sliceReducer/interactionReducer";

import BusinessCenterIcon from "@material-ui/icons/BusinessCenter";
import EditIcon from "@material-ui/icons/Edit";

import ListIcon from "@material-ui/icons/List";
import CloseIcon from "@material-ui/icons/Close";

//material-UI-Style
const StyledTableRow = withStyles((theme: Theme) => createStyles({}))(TableRow);

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    paper: {
      position: "relative",
      width: "1480px",
      height: "860px",
      paddingBottom: "20px",
      backgroundColor: theme.palette.background.paper,
      border: `2px solid #4f5470`,
      boxShadow: theme.shadows[5],
      // padding: theme.spacing(3, 6, 3),
    },

    table: {
      marginTop: "72px",
      border: "1px solid #9e9e9e",
      "& td": {
        padding: "10px",
        border: "1px solid #9e9e9e",
      },
    },
    buttonCell: {
      display: "flex",
      justifyContent: "space-around",
      border: "1px solid #828384",
    },
    modalTitle: {
      position: "fixed",
      width: "1480px",
      padding: "12px 16px",
      textAlign: "center",
      fontSize: "20px",
      fontWeight: "bold",
      backgroundColor: "#4f5470",
      color: "white",
      "& h5": {
        display: "flex",
        alignItems: "center",
        "& svg": {
          paddingRight: "8px",
        },
      },
      "& span": {
        fontSize: "18px",
        fontWeight: "normal",
      },
    },
    searchInput: {
      display: "flex",
      justifyContent: "center",
      marginBottom: " 20px",
    },

    buttonStyle: {
      display: "flex",
      justifyContent: "center",

      "& button": {
        width: "200px",
        height: "40px",
        marginTop: "80px",
      },
    },
    imageBox: {
      width: "100%",
      height: "180px",
      padding: "8px",
      backgroundColor: theme.palette.input.main,
      "& img": {
        height: "100%",
      },
    },
    thStyle: {
      fontWeight: "bold",
      backgroundColor: theme.palette.input.main,
    },
  })
);

const DetailFieldCheck = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const {myProject, fieldCheck} = useSelector((state: RootState) => state.myProject);

  return (
    <TableContainer component={Paper} className={classes.paper}>
      <Box
        className={classes.modalTitle}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >
        <Typography variant="h5" component="h5">
          <BusinessCenterIcon />
          첨부 목록
        </Typography>
        <IconButton onClick={() => dispatch(checkListCloseAction())} aria-label="close">
          <CloseIcon style={{color: "white", fontWeight: "bold"}} />
        </IconButton>
      </Box>
      <Box p="16px">
        <Table className={classes.table} aria-label="simple table">
          <TableBody>
            <StyledTableRow>
              <TableCell className={classes.thStyle} width="200px">
                <p>공장명</p>
              </TableCell>
              <TableCell>
                <p>{myProject.factoryName}</p>
              </TableCell>
              <TableCell className={classes.thStyle} width="200px">
                <p>공정명</p>
              </TableCell>
              <TableCell>
                <p>{fieldCheck.processName}</p>
              </TableCell>
            </StyledTableRow>
            <StyledTableRow>
              <TableCell className={classes.thStyle}>
                <p>항목</p>
              </TableCell>
              <TableCell>
                <p>{fieldCheck.itemName}</p>
              </TableCell>
              <TableCell className={classes.thStyle}>
                <p>위치(설비)명</p>
              </TableCell>
              <TableCell>
                <p>{fieldCheck.specName}</p>
              </TableCell>
            </StyledTableRow>
            <StyledTableRow>
              <TableCell colSpan={2}>
                <div className={classes.imageBox}>
                  <img src={"/uploads/inspect/checkImages/" + fieldCheck.photoFile1} alt="" />
                </div>
              </TableCell>
              <TableCell colSpan={2}>
                <div className={classes.imageBox}>
                  <img src={"/uploads/inspect/checkImages/" + fieldCheck.photoFile2} alt="" />
                </div>
              </TableCell>
            </StyledTableRow>
            <StyledTableRow>
              <TableCell className={classes.thStyle}>
                <p>사진 1 </p>
              </TableCell>
              <TableCell>
                <p>{fieldCheck.photoName1}</p>
              </TableCell>
              <TableCell className={classes.thStyle}>
                <p>사진 2 </p>
              </TableCell>
              <TableCell>
                <p>{fieldCheck.photoName2}</p>
              </TableCell>
            </StyledTableRow>
            <StyledTableRow>
              <TableCell className={classes.thStyle}>
                <p>지적사항</p>
              </TableCell>
              <TableCell colSpan={3}>
                <p>{fieldCheck.notice}</p>
              </TableCell>
            </StyledTableRow>
            <StyledTableRow>
              <TableCell className={classes.thStyle}>
                <p>개선대책</p>
              </TableCell>
              <TableCell colSpan={3}>
                <p>{fieldCheck.improve}</p>
              </TableCell>
            </StyledTableRow>
            <StyledTableRow>
              <TableCell className={classes.thStyle}>
                <p>관련법규</p>
              </TableCell>
              <TableCell colSpan={3}>
                <p>{fieldCheck.regulation}</p>
              </TableCell>
            </StyledTableRow>
          </TableBody>
        </Table>
      </Box>
      <Box display="flex" justifyContent="flex-end" mr="16px">
        <Button
          variant="contained"
          color="secondary"
          startIcon={<ListIcon />}
          onClick={() => {
            dispatch(checkListSwitchAction(0));
          }}
        >
          리스트
        </Button>
        <Button
          style={{marginLeft: "16px"}}
          variant="contained"
          color="primary"
          startIcon={<EditIcon />}
          onClick={() => {
            dispatch(checkListSwitchAction(2));
          }}
        >
          수정
        </Button>
      </Box>
    </TableContainer>
  );
};

export default DetailFieldCheck;
